import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideInRightAnimation = trigger('slideInRightAnimation', [
	state('true', style({ transform: 'translateX(0%)', opacity: '1' })),
	state('false', style({ transform: 'translateX(100%)', opacity: '0' })),
	transition('* <=> *', animate('200ms ease-in-out'))
]);

export const slideInBottomAnimation = trigger('slideInBottomAnimation', [
	state('true', style({ transform: 'translateY(0%)', opacity: '1' })),
	state('false', style({ transform: 'translateY(100%)', opacity: '0' })),
	transition('* <=> *', animate('400ms ease-in-out'))
]); 
